// extracted by mini-css-extract-plugin
module.exports = {"view":"CircleView_view__P9_k7","name":"CircleView_name__3chLb"};